import * as PropTypes from "prop-types";
import SearchSvg from "./green-location-icon.svg";
import Icon from "./Icon";

export default function LocationIcon({ className, style }) {
  const localStyle = {
    minWidth: "1.2rem",
    minHeight: "1.2rem",
    ...style,
  };

  return <Icon src={SearchSvg} className={className} style={localStyle} />;
}

LocationIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

LocationIcon.defaultProps = {
  className: "",
  style: {},
};
